import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { FilesStore, FilesState } from './files.store';

@Injectable({ providedIn: 'root' })
export class FilesQuery extends QueryEntity<FilesState> {
  constructor(protected store: FilesStore) {
    super(store);
  }
}
